export const tiktokConsent = `
<div>
    Wenn Sie TikTok oder die dazugehörigen Dienste nutzen, werden Ihre personenbezogenen Daten sowie Ihr Nutzerverhalten und andere Daten von den Betreibern dieser Plattform zur Profilbildung (z. B. für personalisierte Inhalte und Werbung) gesammelt. Ihre Daten werden mit Dritten geteilt und in Länder wie die USA übermittelt, die nicht das gleiche Datenschutzniveau wie Deutschland bieten. Sie werden dort für geschäftliche Zwecke gespeichert, verarbeitet und an Dritte weitergegeben. Öffentliche Stellen, die einen TikTok-Auftritt haben, sind für diese Datensammlung mitverantwortlich, da sie den Netzwerken die Datensammlung ermöglichen.
</div>

<h1>Welche personenbezogene Daten sammelt TikTok?</h1>

<ul>
    <li>
        Informationen & Inhalte, die Sie mitteilen: Metadaten, Texte, Bilder, Videos, Beziehungsstatus, Bildungsweg, Arbeitgeber, Standortdaten
    </li>
    <li>
        Daten unter besonderem Schutz: Religion, sexuelle Orientierung, politische Orientierung etc.
    </li>
    <li>
        Netzwerke und Verbindungen: Seiten, Gruppen, Profile, Hashtags, Accounts
    </li>
     <li>
        Ihre Nutzung: Features, Interaktionen
    </li>
    <li>
        Informationen über Transaktionen: Zahlungsmethoden & Informationen, Kredit- oder Bankkartennummer
    </li>
    <li>
        Dinge, die andere tun, und Informationen, die andere über Sie bereitstellen: Fotos, Kommentare, Nachrichten, Kontaktinfo, Beziehung
    </li>
</ul>

<h2>Geräte-Informationen</h2>

<ul>
    <li>
        Geräte-Informationen: Computer, Telefone, angeschlossene Fernseher und andere mit dem Internet verbundene Geräte; Betriebssystem, Hardware- und Software-Versionen, Akkustand, Signalstärke, verfügbarer Speicherplatz, Browser-Typ, Namen und Typen von Anwendungen und Dateien sowie Plugins
    </li>
    <li>
        Geräte-Operationen: Mausbewegungen, Operationen und Verhaltensweisen, die auf dem Gerät ausgeführt werden
    </li>
    <li>
        Eindeutige Bezeichner: Geräte- und App-ID’s
    </li>
    <li>
        Geräte-Signale: Bluetooth-Signale und Informationen über nahegelegene Wi-Fi-Zugangspunkte, Funktürme und Mobilfunkmasten
    </li>
    <li>
        Geräte-Signale: Bluetooth-Signale und Informationen über nahegelegene Wi-Fi-Zugangspunkte, Funktürme und Mobilfunkmasten
    </li>
    <li>
        Netzwerk und Verbindungen: Name Ihres Mobilfunkbetreibers oder ISP, Sprache, Zeitzone, Mobiltelefonnummer, IP-Adresse, Verbindungsgeschwindigkeit
    </li>
    <li>
        Cookie-Daten: Gespeicherte Cookies, einschließlich Cookie-IDs und Einstellungen
    </li>
</ul>

<h2>
    Informationen, die von Partnern von TikTok eingesammelt werden:
</h2>


<ul>
    <li>
        Partner, das bedeutet: Werbetreibende, App-Entwickler und Verleger
    </li>
    <li>
        Diese sammeln über soziale Plug-ins (wie die Schaltfläche "Like"), APIs und SDKs oder Pixel die oben genannten Informationen
    </li>
</ul>

<h1>
    Wie benutzt TikTok Ihre personenbezogene Daten? 
</h1>
    
<h2>
    Bereitstellung, Personalisierung und Verbesserung der TikTok-Produkte
</h2>

<ul>
    <li>
        TikTok-Produkte und -Geräte: Damit TikTok ein individuelles und einheitliches Erlebnis in allen TikTok-Produkten, auch durch Automatisierung, gewährleisten kann
    </li>
    <li>
        Standortbezogene Informationen: Damit TikTok seine Produkte, einschließlich Werbeanzeigen, bereitstellen kann
    </li>
    <li>
        Produktforschung und -entwicklung: Damit TikTok seine Produkte entwickeln, erproben und verbessern kann
    </li>
    <li>
        Gesichtserkennung: Damit TikTok Sie auf Fotos bzw. in Videos und Kameraerlebnissen wiedererkennen kann
    </li>
    <li>
        Werbeanzeigen und andere gesponserte Inhalte: Damit TikTok die Werbeanzeigen, Angebote und sonstige gesponserten Inhalte auswählen und personalisieren kann
    </li>
</ul>

<h2>Bereitstellung von Messungen, Analysen und sonstigen Unternehmens-Services</h2>

<ul>
    <li>
        TikTok nutzt Ihre Aktivitäten außerhalb der TikTok-Produkte, wie z. B. die von Ihnen besuchten Websites und die Werbeanzeigen, zur Optimierung seiner Produkte
    </li>
</ul>

<h2>
    Förderung von Schutz, Integrität und Sicherheit
</h2>

<ul>
    <li>
        TikTok nutzt Ihre personenbezogene Daten, um Aktivitäten und Konten zu verifizieren, schädliches Verhalten zu bekämpfen, Spam und andere negative Erlebnisse aufzudecken, die Integrität der TikTok-Produkte zu wahren und den Schutz sowie die Sicherheit zu fördern
    </li>
</ul>

<h2>
    Kommunikation zwischen TikTok und Ihnen
</h2>

<ul>
    <li>
        TikTok nutzt Ihre personenbezogene Daten, um Ihnen Marketing-Kommunikationen zu senden, mit Ihnen über TikTok-Produkte zu kommunizieren und Sie über die TikTok-Richtlinien und Nutzungsbedingungen zu informieren
    </li>
</ul>

<h2>
    Forschung und Innovation für soziale Zwecke
</h2>

<ul>
    <li>
        TikTok nutzt Ihre personenbezogene Daten, um Forschung und Innovation durchzuführen und zu unterstützen
    </li>
</ul>


<h1>
    Wie teilt TikTok Ihre personenbezogene Daten?
<h1>

<h2>
    Teilen auf TikTok-Produkten
</h2>

<ul>
    <li>
        TikTok teilt Personen und Konten, mit denen Sie Inhalte teilen bzw. kommunizieren
    </li>
    <li>
        Öffentliche Informationen können von jedem auf oder außerhalb der TikTok-Produkte gesehen werden. Dies umfasst auch Ihren Benutzernamen. Ihre Inhalte können erneut geteilt oder heruntergeladen werden
    </li>
    <li>
        TikTok teilt Inhalte, die andere über Sie (erneut) teilen
    </li>
    <li>
        TikTok teilt Informationen über Ihren aktiven Status oder Ihre Anwesenheit auf den TikTok-Produkten
    </li>
    <li>
        Personen in Ihren Netzwerken können Signale sehen, denen sie entnehmen können, ob Sie auf den TikTok-Produkten aktiv sind
    </li>
    <li>
        TikTok teilt Apps, Websites und Integrationen Dritter, die auf den TikTok-Produkten laufen bzw. diese nutzen
    </li>
    <li>
        Was Sie posten oder teilen, Ihr öffentliches Profil auf TikTok sowie jede Information, die Sie mit Dritten teilen
    </li>
    <li>
        Die von diesen Diensten Dritter erfassten Informationen unterliegen deren eigenen Nutzungsbedingungen und Richtlinien und nicht der Datenrichtlinie von TikTok
    </li>
    <li>
        Geräte und Betriebssysteme, die native Versionen von TikTok bereitstellen, haben Zugriff auf sämtliche Informationen, die Sie teilen, einschließlich der Informationen, die Ihre TikTok-Kontakte mit Ihnen teilen
    </li>
    <li>
        Wenn angehörige Personen unter besonderen Umständen Ihren TikTok-Account erben: Sollten sich Eigentums- oder Machtverhältnisse ändern, werden Informationen von TikTok an den neuen Eigentümer übertragen
    </li>
</ul>

<h2>
    Teilen mit Drittpartnern
</h2>

<ul>
    <li>
        Partner, die die Analysedienste von TikTok nutzen: TikTok teilt zusammengefasste Statistiken und Einblicke über Ihre demografischen und interessenbezogenen Informationen
    </li>
    <li>
        Werbetreibende auf TikTok: TikTok teilt die Arten von Personen, die die Werbeanzeigen der Werbetreibenden sehen, den Erfolg dieser Anzeigen und welche TikTok-Werbeanzeigen Sie dazu veranlasst haben, einen Kauf zu tätigen oder eine Handlung durchzuführen
    </li>
    <li>
        TikTok-Partner für Messungen: TikTok stellt seinen Partnern Berichte über Analysen und Messungen bereit
    </li>
    <li>
        TikTok-Partner, die Waren und Dienstleistungen in TikTok-Produkten anbieten: TikTok teilt personenbezogene Daten, die zum Abschluss der Transaktion erforderlich sind, einschließlich Versand- und Kontaktangaben
    </li>
    <li>
        Anbieter und Dienstleister: TikTok stellt Anbietern und Dienstleistern, die TikTok unterstützen, Ihre personenbezogenen Daten und Inhalte bereit
    </li>
    <li>
        Forscher und Wissenschaftler: TikTok stellt Ihre personenbezogenen Daten zur Unterstützung von Forschung und Innovation seines Unternehmens und der Entdeckung und Innovation zu Themen des sozialen Allgemeinwohls bereit
    </li>
    <li>
        Strafverfolgungs- bzw. Vollstreckungsbehörden oder rechtliche Anfragen: TikTok teilt Ihre personenbezogene Informationen unter Umständen mit Strafverfolgungs- bzw. Vollstreckungsbehörden oder als Reaktion auf rechtliche Anfragen
    </li>
</ul>

<h1>
Wie verarbeitet und übermittelt TikTok Ihre personenbezogene Daten im Rahmen seiner globalen Dienste? 
</h1>

<div>
    TikTok teilt Ihre personenbezogenen Daten weltweit, sowohl intern zwischen den Unternehmen als auch extern mit Partnern sowie mit denen, mit denen Sie sich auf der ganzen Welt verbinden und mit denen Sie etwas teilen. Nach dem Urteil des Europäischen Gerichtshofs vom 16. Juli 2020 (Rs. C-311/18 - „Schrems II“) können Datenübermittlungen in die USA nicht mehr über das US-amerikanische „Privacy Shield“ durchgeführt werden, auf das sich TikTok bisher gestützt hat. Auch die Nutzung von Standardvertragsklauseln ist bei einer Übermittlung in die USA nur bei der Implementierung zusätzlicher Garantien - etwa einer Ende-zu-Ende-Verschlüsselung - möglich. Dies ist bei TikTok derzeit nicht der Fall.
</div>
`;
